import { GENDER } from '@vindr/services/constants/common.constant';
import { ColumnType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';

const genderColumn = ({
  title = 'Gender',
  dataIndex = 'sex',
  key = 'sex',
  width = 50,
  ...props
}: ColumnType<any> = {}): any => {
  const { t } = useTranslation('Vindoc');

  return {
    title: t(title),
    dataIndex,
    width,
    key,
    render: (text) => t(GENDER[text]),
    ...props,
  };
};

export default genderColumn;
